import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import {
  updateMessageMask,
  updatedMessageMask,
  fetchMessageMask,
  fetchedMessageMask,
  fetchedMessagesMasks,
  fetchMessagesMasks,
  fetchSituationsByClientType,
  fetchedSituationsByClientType,
} from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type UpdateMessageMaskActionPayload = ReturnType<typeof updateMessageMask>;
type FetchMessageMaskActionPayload = ReturnType<typeof fetchMessageMask>;
type FetchMessageMasksActionPayload = ReturnType<typeof fetchMessagesMasks>;
type FetchSituationsByClientTypeActionPayload = ReturnType<typeof fetchSituationsByClientType>;

export function* getMessagesMasksSaga({ meta: { callback } }: FetchMessageMasksActionPayload) {
  const { getMessageMasks } = getAPI();
  const response: YieldOf<typeof getMessageMasks> = yield call(getMessageMasks);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedMessagesMasks(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedMessagesMasks(undefined, error));
  }

  if (callback) callback();
}

export function* getMessageMaskSaga({ meta: { situationId, callback } }: FetchMessageMaskActionPayload) {
  const { getMessageMask } = getAPI();
  const response: YieldOf<typeof getMessageMask> = yield call(getMessageMask, situationId);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedMessageMask(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedMessageMask(undefined, error));
  }

  if (callback) callback();
}

export function* updateMessageMaskSaga({ meta: { messageMask, callback } }: UpdateMessageMaskActionPayload) {
  const { updateMessageMaskApi } = getAPI();
  const response: YieldOf<typeof updateMessageMaskApi> = yield call(updateMessageMaskApi, messageMask);
  const { ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(updatedMessageMask());
    if (callback) yield call(callback);
  } else {
    const error = problem || 'unknown';
    yield put(updatedMessageMask(undefined, error));
  }
}

export function* getSituationsByClientTypeSaga({ payload }: FetchSituationsByClientTypeActionPayload) {
  const { getSituationsMessageMaskByClientType } = getAPI();
  const response: YieldOf<typeof getSituationsMessageMaskByClientType> = yield call(
    getSituationsMessageMaskByClientType,
    payload
  );
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedSituationsByClientType(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedSituationsByClientType(undefined, error));
  }
}

export default function* MessageMaskSaga() {
  yield takeLatest(fetchMessagesMasks.type, getMessagesMasksSaga);
  yield takeLatest(fetchMessageMask.type, getMessageMaskSaga);
  yield takeLatest(updateMessageMask.type, updateMessageMaskSaga);
  yield takeLatest(fetchSituationsByClientType.type, getSituationsByClientTypeSaga);
}
